module.exports = __webpack_public_path__ + "static/media/butter-robot-image-2.1b96cfc6.jpg";